<!--
Copyright 2020 SMART Methodology
Copyright 2019 ODK Central Developers
See the NOTICE file at the top-level directory of this distribution and at
https://github.com/getodk/central-frontend/blob/master/NOTICE.

NOTICE: THIS FILE HAS BEEN MODIFIED BY SMART Methodology UNDER COMPLIANCE WITH THE
APACHE 2.0 LICENCE FROM THE ORIGINAL WORKOF THE COMPANY ODK Central. THE FOLLOWING
IS THE COPYRIGHT OF THE ORIGINAL DOCUMENT:

This file is part of ODK Central. It is subject to the license terms in
the LICENSE file found in the top-level directory of this distribution and at
https://www.apache.org/licenses/LICENSE-2.0. No part of ODK Central,
including this file, may be copied, modified, propagated, or distributed
except according to the terms contained in the LICENSE file.
-->

<template>
  <div id="account-claim" class="row">
</div>
</template>

<script>
import request from '../../mixins/request';
import { i18n } from '../../localization';

export default {
  name: 'AccountActivate',
  mixins: [request()],
  data() {
    return {
      awaitingResponse: false
    };
  },
  mounted() {
    this.submit();
  },
  methods: {
    submit() {
      const headers = {};
      const { token } = this.$route.query;
      if (token != null) headers.Authorization = `Bearer ${token}`;
      this.request({
        method: 'POST',
        url: '/users/activate',
        headers,
        data: { },
        problemToAlert: ({ code, message }) => (code === 401.2
          ? i18n.t('components.notifications.linkInYourEmailMayHaveExpired', { message })
          : null)
      })
        .then(() => {
          this.$router.push('/login', () => {
            this.$alert().success(i18n.t('components.notifications.accountHasBeenActivated'));
          });
        })
        .catch(() => {
          this.$router.push('/login');
        });
    }
  }
};
</script>
